<div [ngClass]="schema?.classNames?.widget">
	<label [attr.for]="id" [ngClass]="schema?.classNames?.title">{{ schema.title }}</label>
	<input
		[ngClass]="schema?.classNames?.input || 'form-control form-control-primary'"
		[attr.id]="id"
		[attr.type]="'number'"
		[attr.min]="schema.minimum"
		[attr.max]="schema.maximum"
		[attr.placeholder]="schema.placeholder"
		[attr.maxLength]="schema.maxLength || null"
		[attr.minLength]="schema.minLength || null"
		[attr.readonly]="schema.readOnly ? true : null"
		[formControl]="control"
	/>
</div>

<div class="validation-error">
	{{ control.errors | sfValidationError: schema : control.value }}
</div>
